module.exports = __webpack_public_path__ + "public/SiteIcons/heartFill.svg?80e093c9";